export default {
    type: 'person-citations',
    aliases: {
        camel: 'personCitations',
        singular: 'Person citation',
        plural: 'Person citations',
        lowerSingular: 'person citation',
        lowerPlural: 'person citations',
    },
    publishable: false,
    adminSection: null,
    componentType: 'pivot',
    components: {}
};
